// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__2WPTy","container":"LayoutSideNavigation_container__3knEL","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__2fATC"};